import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "../models/user";
import { ApplicationPool } from "../services/application.pool";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
})
export class LoadingComponent implements OnInit {
  constructor(
    private dataPool: ApplicationPool,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(
        [
          "/" +
            decodeURI(
              window.location.pathname
                .replace("loading/", "")
                .replace("%2F", "/")
            )
              .replace("%2F", "/")
              .replace("%252F", "/"),
        ],
        { replaceUrl: true }
      );
    }, 500);
  }
}
